<template>
    <div class="alipayPage">
        <div class="over">
            <div class="bgBox"><img src="./../../../../assets/home/bg-top.png" alt=""></div>
        </div>
        <div class="top"></div>
        <div class="header">
            <router-link to="/home/usercenter/userinfo" tag="i"> <img src="./../../../../assets/home/back.jpg" alt=""> </router-link>
            <span>绑定支付宝</span>
        </div>

        <div class="content">
            <div class="alipay">
                <span class="title">真实姓名</span>
                <input type="text"  v-model="alipayName" placeholder="请输入支付宝姓名" ref="getName" :disabled="alipayNamec?true:false">
            </div>
            <div class="alipay">
                <span class="title">账号</span>
                <input type="text"  v-model="alipayNumber" placeholder="请输入支付宝账号" ref="getNumber" :disabled="alipayNamec?true:false">
            </div>
            <div class="alipay">
                <span class="title">身份证号</span>
                <input type="text" placeholder="请输入身份证号" ref="getIdNumber">
            </div>
            <p class="info">tips:请输入正确的信息，否则无法提现</p>
        </div>

        <div class="btn" @click="bind">绑定</div>
    </div>
</template>

<script>
export default {
    
    data(){
        return {
            alipayNamec:localStorage.getItem("UserAlipayName"),
            alipayName:localStorage.getItem("UserAlipayName"),
            alipayNumber:localStorage.getItem("UserAlipay"),
        }
    },
    methods:{
        ishais(){
            this.$refs.getNumber
        },
        testID(ID){
            let str = ID
            let arr = ["1","0","X","9","8","7","6","5","4","3","2"]
            let num = (str[0]*7)+(str[1]*9)+(str[2]*10)+(str[3]*5)+(str[4]*8)+(str[5]*4)+(str[6]*2)+(str[7]*1)+(str[8]*6)+(str[9]*3)+(str[10]*7)+(str[11]*9)+(str[12]*10)+(str[13]*5)+(str[14]*8)+(str[15]*4)+(str[16]*2)
            if(str.length !== 18){
                return false
            }else if(str[17] === arr[num % 11]){
                return true
            }else{
                return false
            }
        },
        bind(){
            let _this = this
            let reg = /^((?![\u3000-\u303F])[\u2E80-\uFE4F]|\·)*(?![\u3000-\u303F])[\u2E80-\uFE4F](\·)*$/ //中文检测
            let name = _this.$refs.getName.value
            let number = _this.$refs.getNumber.value
            let idNumber = _this.$refs.getIdNumber.value
            let alipayName = localStorage.getItem("UserAlipayName")
            if((!name || !reg.test(name))&&!alipayName){
                alert("请输入中文姓名")
            }else if(!number&&!alipayName){
                alert("请输入支付宝账号")
            }else if(!_this.testID(idNumber)){
                alert("身份证填写错误")
            }else{
                if(confirm("确定绑定\n姓名:" + name + "\n账号:" + number + "\n的支付宝账号吗？")){
                    
                    function setupWebViewJavascriptBridge(callback) {                                            
                        if (window.WebViewJavascriptBridge) { 
                            return callback(WebViewJavascriptBridge); 
                        }       
                        if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback); }              
                        window.WVJBCallbacks = [callback];                                                        
                        var WVJBIframe = document.createElement('iframe');                                        
                        WVJBIframe.style.display = 'none';                                                        
                        WVJBIframe.src = 'https://__bridge_loaded__';                                             
                        document.documentElement.appendChild(WVJBIframe);                                                
                        setTimeout(function() { 
                            document.documentElement.removeChild(WVJBIframe) 
                        }, 0)                  
                    }                                                                                                      
                    setupWebViewJavascriptBridge(function(bridge) { 
                        bridge.callHandler('encrypt', {
                            uid : localStorage.getItem("UID"),
                            token : localStorage.getItem("UserToken"),
                            alipay : number,
                            alipayname : name,
                            identity_card_number : idNumber,
                            request_time : Date.parse(new Date())
                        }, function(response) {        //加密获取到的数据 
                            let userInfoCode = response.dataReq
                            let userInfoSign = response.dataSign
                            _this.$axios.post("/api/user/bindali", {      
                                code : userInfoCode,
                                dataSign : userInfoSign,
                            }).then(res=>{
                        if(res.data.msg == '页面超时，请返回首页'){
                            alert(res.data.msg);
                            _this.$router.push({path:"/home"})
                            return;
                        }
                                if(res.data.status === 1){
                                    _this.$router.push({path:'/home/usercenter/userinfo'})
                                }else{
                                    alert(res.data.msg)
                                }
                            })
                        })
                    })
                }
            }
        }
    },
    
    
}
</script>

<style lang="scss" scoped>

    .over{
        width:100%;
        height:.60rem;
        overflow: hidden;
        position: absolute;
        top:0;
        z-index: -1;
    }
    .bgBox{
        width:100%;
        height:2.32rem;
    }

    // header
    .top{
        height:.2rem;
    }
    .header{
        width:90%;
        height:.40rem;
        margin-left: 5%;
        display: flex;
        justify-content: center;
        align-items: center;
        position:relative;
        margin-bottom: .1rem;
        span{
            font-size: .18rem;
            line-height: .40rem;
        }
        i{
            position:absolute;
            left:0.05rem;
            width:.26rem;
            height:.16rem;
            padding-right:.16rem;
        }
    }

    // content
    .content{
        width:90%;
        margin-left:5%;
        .alipay{
            width:100%;
            height:0.5rem;
            border-bottom: 1px solid #D8D8D8;
            display:flex;
            align-items: center;
            .title{
                font-size: 0.16rem;
                color:#555555;
                width:.7rem;
            }
            input{
                width:2rem;
                margin-left:0.32rem;
                font-size: 0.16rem;
                background-color: transparent;
            }
            
        }
    }
    .info{
        margin-top:.3rem;
        font-size: .12rem;
        color:#555;
        width:100%;
        text-align: center;
    }
    .btn{
        width:1.1rem;
        height:0.4rem;
        font-size: 0.16rem;
        text-align: center;
        line-height: 0.4rem;
        background: linear-gradient(112deg, #FFDF42 0%, #FFEC77 100%);
        border-radius: 0.18rem;
        margin:.3rem auto;
    }
</style>

